export default __webpack_public_path__ + "static/1353-2531d67c5c22bd8f0cdbfdc15d5de53f.gif";